export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["MultipleCheckbox"] = "MultipleCheckbox";
})(FilterTypes || (FilterTypes = {}));
//# sourceMappingURL=types.js.map